module.exports = __webpack_public_path__ + "img/thumbmad1.340da98c.png";